import type { SITE_PHOTO_FILTERS_BUTTON_FRENCH_LOCALE } from "~ui/@application/locales/modules/components/site-photo-filters-button/site-photo-filters-button.fr.ts";

export const SITE_PHOTO_FILTERS_BUTTON_ENGLISH_LOCALE = {
  sortBy: {
    date: "Date",
    photoType: "Photo type",
  },
  photoType: "Photo type",
} satisfies typeof SITE_PHOTO_FILTERS_BUTTON_FRENCH_LOCALE;
